<template>
    <div class="flex-page">
      <a-form
        class="form"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-form-item label="简介内容">
          <Editor
          v-if="data_got"
            @callback="updateEditor"
            :data="form.content"
            folder="article"
          />
        </a-form-item>
      </a-form>
      <div class="buttons">
        <a-button type="primary" @click="sub">提交保存</a-button>
      </div>
    </div>
  </template>
  
  <style lang="scss" scoped>
  .files {
    margin-top: 20px;
    .file {
      height: 32px;
      line-height: 24px;
    }
  }
  </style>
  
  <script>
  import Editor from "../../components/editor";
  
  export default {
    components: { Editor },
    data() {
      return {
        formItemLayout: {
          labelCol: {
            span: 3,
          },
          wrapperCol: {
            span: 20,
          },
        },
        data_got: false,
        form: {
          content: "",
        },
      };
    },
    async created() {
      
    },
    async mounted() {
      const id = this.$route.query.id;
      const r = await this.$axios.get("/shellCity/getJianjieDetail");
  
      if ((r.status = 1)) {
        this.form = r.detail;
        this.data_got = true
      } else {
        this.$message.error(r.msg);
      }
    },
    methods: {
      async sub() {
        const that = this;
        const r = await that.$axios.post("/shellCity/updateJianjie", this.form);
        if (r.status == 1) {
        }
      },
      updateEditor(data) {
        this.form.content = data;
      },
    },
  };
  </script>
